const updateHeightOfSameLevelElements = (productSelectors = [], elementSelector = '') => {
  // clearing the heights if they are set
  productSelectors.forEach((productSelector) => {
    const elementToChangeHeight = document.querySelector(`${productSelector} ${elementSelector}`);
    if (elementToChangeHeight.style.height) {
      elementToChangeHeight.style.height = '';
    }
  });

  // get maxHeight
  const maxHeight = Math.max(
    ...productSelectors.map(
      (productSelector) => document.querySelector(`${productSelector} ${elementSelector}`).clientHeight
    )
  );

  // setting the height for elements
  productSelectors.forEach((productSelector) => {
    const elementToChangeHeight = document.querySelector(`${productSelector} ${elementSelector}`);
    elementToChangeHeight.style.height = `${maxHeight}px`;
  });
};

const checkIfAllImagesLoadingFinished = (productSelectors) => {
  const allImagesInRowSelector = `${productSelectors.join(' img, ')} img`;
  const imgElements = document.querySelectorAll(allImagesInRowSelector);

  if (imgElements.length > 0) {
    if (Array.from(imgElements).every((imgElement) => imgElement.complete)) {
      return true;
    }
    return false;
  }
  return true;
};

const updateHeightsForAllLevelsOfGridRow = (productSelectors) => {
  updateHeightOfSameLevelElements(productSelectors, '.product-images');
  updateHeightOfSameLevelElements(productSelectors, '.badges');
  updateHeightOfSameLevelElements(productSelectors, '.countdownLabels');
  updateHeightOfSameLevelElements(productSelectors, '.productBundle');
  updateHeightOfSameLevelElements(productSelectors, '.reevoo-placeholder');
  updateHeightOfSameLevelElements(productSelectors, '.promoMessages');
  updateHeightOfSameLevelElements(productSelectors, '.productDescription');
  updateHeightOfSameLevelElements(productSelectors, '.productPrices');
  updateHeightOfSameLevelElements(productSelectors, '.online-credit-message-wrapper');
  updateHeightOfSameLevelElements(productSelectors, '.countdownMessage');
  updateHeightOfSameLevelElements(productSelectors, '.channels-availability');
  updateHeightOfSameLevelElements(productSelectors, '.product-desc');
};

export const updateHeightsOfOneGridRow = (productIDs = []) => {
  const productSelectors = productIDs.map((productID) => `article#${productID}.product`);

  // check if all images in grid row are loaded to set heights correctly
  if (!checkIfAllImagesLoadingFinished(productSelectors)) {
    // not all images have been downloaded yet so we create interval for checking
    const interval = setInterval(() => {
      if (checkIfAllImagesLoadingFinished(productSelectors)) {
        // all images are loaded so we can stop interval and set the heights
        clearInterval(interval);
        updateHeightsForAllLevelsOfGridRow(productSelectors);
      }
    }, 200);
  } else {
    // all images are loaded so we can set the heights
    updateHeightsForAllLevelsOfGridRow(productSelectors);
  }
};
